import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

let Bar

const ProductAnalyticsDemandChart = ({ data, labels }) => {
  const [isLoaded, setIsLoaded] = useState()

  useEffect(() => {
    import('react-chartjs-2').then(module => {
      Bar = module.Bar
      setIsLoaded(true)
    })
  }, [])

  if (!isLoaded) return null

  const chartConfiguration = {
    data: {
      labels,
      datasets: [
        {
          label: 'Liquidity',
          data,
          backgroundColor: 'rgba(103, 196, 176, 0.8)',
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [{ display: false }],
      },
      legend: {
        onClick: (e) => e.stopPropagation(),
      },
      tooltips: {
        enabled: false,
      },
    },
  }

  return (
    <div className="chart-container">
      <div className="chart-container__description">
        <h3>Liquidity (Deficit)</h3>
        <p>
          This chart shows which categories are the most liquid or deficit (sales divided by the number of
          models). If sales in the category is relatively high compared to the number of models it means the
          higher chance to sell.
        </p>
      </div>

      <div className="chart-container__chart">
        <Bar redraw data={chartConfiguration.data} options={chartConfiguration.options} />
      </div>
    </div>
  )
}

ProductAnalyticsDemandChart.propTypes = {
  data: PropTypes.array,
  labels: PropTypes.array,
}

ProductAnalyticsDemandChart.defaultPropTypes = {
  data: [],
  labels: [],
}

export default ProductAnalyticsDemandChart
